import Image from "../../../../components/elements/Image";
import { lngDetect } from "../../../../helpers/lngDetect";
import dayjs from "dayjs";
import Button from "../../../../components/form/Button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import QrTicketDetails from "./QrTicketDetails";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  orderCancel,
  orderStatusChange,
} from "../../../../services/orderService";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Badge from "../../../elements/Badge";
import { toast } from "react-toastify";
import ConfirmModal from "../../../common/ConfirmModal";
import { useState } from "react";
import { chatCreate } from "../../../../services/chatService";
import PayRemaining from "./PayRemaining";
import EventReportModal from "../event-manage/EventReportModal";
import paypal from "../../../../assets/images/paypalText.png";
import stripe from "../../../../assets/images/stripe.svg";
import { t } from "i18next";
import { classNames } from "../../../../helpers/classNames";

const statusMap = {
  processing: "processing",
  completed: "success",
  failed: "danger",
  pending: "pending",
  canceled: "danger",
  cancelled: "danger",
  confirmed: "confirmed",
  "partial-refund": "partialRefund",
};

const TicketInfo = ({ orderData = {}, getResponse = () => {} }) => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const { lang } = useSelector((state) => state?.langProvider);
  const queryClient = useQueryClient();

  const { mutate: cancelOrderRequestHandler, isPending } = useMutation({
    mutationFn: async () => {
      const res = await orderStatusChange({
        ids: orderData?._id,
        status: "cancel-request",
      });
      return { orderData, res };
    },
    onSuccess: ({ orderData, res }) => {
      if (res?.status === 200) {
        toast.success(res?.message);
        queryClient.setQueryData(["order-ticket-item", orderId], (state) => {
          const state_data = JSON.parse(JSON.stringify(state || {}));
          state_data.data.status = {
            ...state_data.data.status,
            info: "cancel-request",
            data: new Date(),
          };
          return { ...state_data };
        });
        setConfirmModalOpen(false);
        getResponse(res);
      } else {
        toast.error(res?.message || res?.error);
      }
    },
  });

  const { mutate: chatStartHandler } = useMutation({
    mutationFn: async (val) => {
      const res = chatCreate({ event: orderData?.eventData?._id });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 201 || res?.status === 200) {
        navigate(`/${lang}/user/communication?id=${res?.data?.uid}`);
      } else {
        toast.warning(res?.error || res?.message || "Something went wrong");
      }
    },
  });

  function isPaymentComplete({ isFullPaid, status }) {
    if (status === "confirmed" && isFullPaid) {
      return true;
    }
    if (status === "processing" && isFullPaid) {
      return false;
    }
    if (status === "processing" && !isFullPaid) {
      return false;
    }
  }

  console.log(orderData?.eventData?.currency?.symbol);

  return (
    <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 w-full hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline bg-white/80 backdrop-blur border-slate-200 group">
      <div className="relative h-56 bg-slate-100">
        <Image
          src={orderData?.eventData?.gallery?.[0]?.url}
          classes="w-full h-full object-cover"
        />
        {/* <div className="absolute top-4 right-4 bg-white rounded-md overflow-hidden">
          <div className="flex flex-col px-4 py-2 items-center justify-center">
            <div className="text-black font-light items-center text-sm">
              {dayjs(orderData?.eventData?.endDate).format("DD")}
            </div>
            <div className="text-black items-center text-sm uppercase font-medium">
              {dayjs(orderData?.eventData?.endDate).format("MMM")}
            </div>
          </div>
          <div className="bg-primary text-white text-sm font-medium text-center py-1">
            {dayjs(orderData?.eventData?.endDate).format("YYYY")}
          </div>
        </div> */}
      </div>

      <div className="px-6 py-5 space-y-4">
        <div className="flex justify-between items-start gap-4">
          <h2 className="text-xl font-bold text-slate-900 leading-snug flex-1">
            {lngDetect(orderData?.eventData?.title)}
          </h2>
          {/* <Button
            buttonClasses="w-10 h-10 rounded-full bg-white hover:bg-slate-100 border border-slate-200 text-slate-700 shadow-sm"
            buttonIcon="fa-regular fa-share-from-square text-base"
          /> */}
        </div>

        <div className="space-y-2 text-sm text-slate-600">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-md bg-primary/10 justify-center flex-shrink-0 border border-primary/10 flex items-center">
              <i className="fa-regular fa-calendar-days text-primary" />
            </div>
            {dayjs(orderData?.eventData?.startDate).format(
              "DD MMM YYYY • hh:mm A"
            )}
            <span>-</span>
            {dayjs(orderData?.eventData?.endDate).format(
              "DD MMM YYYY • hh:mm A"
            )}
          </div>
          {orderData?.eventData?.address?.name && (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-md bg-primary/10 justify-center flex-shrink-0 border border-primary/10 flex items-center">
                <i className="fa-solid fa-location-dot text-primary" />
              </div>
              {orderData?.eventData?.address?.name}
            </div>
          )}
        </div>

        <div className="bg-slate-50 border border-slate-200 pt-5 pb-2 px-2 2xl:p-4 rounded-xl text-sm space-y-1 relative">
          <div className="flex items-center gap-1">
            <span className="font-semibold text-slate-700">
              {t("Order No")}:
            </span>
            {orderData?.orderId}
          </div>
          <div className="flex items-center gap-1">
            <span className="font-semibold text-slate-700">
              {t("Ordered On")}:
            </span>
            {dayjs(orderData?.createdAt).format("ddd, MMM DD, hh:mm A")}
          </div>
          {(orderData?.payment?.gateway === "stripe" ||
            orderData?.payment?.gateway === "paypal") && (
            <div className="flex items-center gap-1">
              <span className="font-semibold text-slate-700 whitespace-nowrap">
                {t("Payment By")}:
              </span>
              <div className="h-5">
                <Image
                  src={
                    orderData?.payment?.gateway === "stripe"
                      ? stripe
                      : orderData?.payment?.gateway === "paypal" && paypal
                  }
                  classes={classNames(
                    "w-10 !object-contain",
                    orderData?.payment?.gateway === "stripe"
                      ? "scale-[1.8]"
                      : ""
                  )}
                />
              </div>
            </div>
          )}
          <div className="pt-5">
            <div className="space-y-1">
              <div className="flex items-center gap-1 justify-between font-medium">
                <span className="font-semibold text-slate-700">
                  {t("Sub-total price")}
                </span>
                {orderData?.eventData?.currency?.symbol || "$"}{" "}
                {parseFloat(orderData?.subtotal || 0)?.toFixed(2)}
              </div>
              <div className="flex items-center gap-1 justify-between font-medium">
                <span className="font-semibold text-slate-700">
                  {t("Transaction fee")}
                </span>
                {orderData?.eventData?.currency?.symbol || "$"}{" "}
                {parseFloat(
                  orderData?.organizationTransactionFee || 0
                )?.toFixed(2)}
              </div>
              <div className="flex items-center gap-1 justify-between font-medium">
                <span className="font-semibold text-slate-700">Sales Tax</span>
                {orderData?.eventData?.currency?.symbol || "$"}{" "}
                {parseFloat(orderData?.taxTotal || 0)?.toFixed(2)}
              </div>
              {orderData?.promoterDiscountTotal > 0 && (
                <div className="flex items-center gap-1 justify-between font-medium">
                  <span className="font-semibold text-slate-700">
                    {t("Promoter fee")}
                  </span>
                  <span className="text-red-400">
                    <i className="fa-light fa-minus"></i>{" "}
                    {orderData?.eventData?.currency?.symbol || "$"}{" "}
                    {parseFloat(orderData?.promoterDiscountTotal || 0)?.toFixed(
                      2
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center gap-1 border-t border-gray-200 pt-2 justify-between mt-1 font-medium">
              <span className="font-semibold text-slate-700">
                {t("Total Price")}
              </span>
              {orderData?.eventData?.currency?.symbol || "$"}{" "}
              {parseFloat(orderData?.total || 0)?.toFixed(2)}
            </div>
            {!isPaymentComplete({
              isFullPaid: orderData?.fullPaid === "yes",
              status: orderData?.status?.info,
            }) && <PayRemaining orderData={orderData} />}
          </div>
          <div className="flex items-center gap-1 absolute -top-4 right-2">
            {/* <span className="font-semibold text-slate-700">Status:</span> */}
            <Badge
              type={statusMap?.[orderData?.status?.info]}
              label={orderData?.status?.info}
            />
          </div>
        </div>

        {orderData?.status?.info !== "canceled" && (
          <div className="relative">
            <Swiper
              slidesPerView={1}
              // autoplay={{ delay: 3000 }}
              pagination={{ clickable: true }}
              modules={[Autoplay, Pagination]}
              className="w-full"
            >
              {orderData?.orderItemData?.map((ticket, idx) => (
                <SwiperSlide key={idx}>
                  {isPaymentComplete({
                    isFullPaid: orderData?.fullPaid === "yes",
                    status: orderData?.status?.info,
                  }) && (
                    <div className="flex flex-col items-center gap-2">
                      <QrTicketDetails
                        ticket={{
                          ...ticket,
                          orderId: orderData?.orderId || "",
                          eventId: orderData?.eventId,
                        }}
                      />
                      <div className="text-xs text-slate-500">
                        {t("Ticket")} {idx + 1} of{" "}
                        {orderData?.orderItemData?.length || 0}
                      </div>
                    </div>
                  )}
                  {!isPaymentComplete({
                    isFullPaid: orderData?.fullPaid === "yes",
                    status: orderData?.status?.info,
                  }) && (
                    <div className="flex items-center justify-center gap-2 text-xs bg-amber-100 text-amber-600 py-2 px-3 rounded-md w-fit mx-auto font-medium">
                      <i className="fa-light fa-file-exclamation"></i>{" "}
                      {t("Full payment is not compleated")}
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        <div className="flex items-center justify-between gap-3 flex-col 2xl:flex-row">
          {orderData?.status?.info === "confirmed" && (
            <Button
              buttonLabel="Cancel Order Request"
              buttonLabelClasses="capitalize text-sm text-red-500"
              buttonIcon="fa-solid fa-ban text-red-500"
              buttonClasses="!w-full bg-white border border-red-500 rounded-xl hover:bg-red-100/50 shadow-sm px-2 py-1 text-xs h-auto w-52 2xl:w-auto"
              buttonFunction={() => {
                setConfirmModalOpen(true);
              }}
            />
          )}
          <EventReportModal
            event={orderData?.eventData}
            buttonClass={
              "!w-full !h-9 flex justify-center items-center text-rose-600 !bg-white border border-red-500 rounded-xl px-2 py-1 text-sm w-52 font-medium 2xl:w-auto"
            }
          />
        </div>
      </div>

      <button
        onClick={chatStartHandler}
        type="button"
        className="bg-primary text-white w-9 h-9 rounded-full absolute top-2 left-2 flex items-center justify-center"
      >
        <i className="fa-solid fa-message text-xs"></i>
      </button>
      <ConfirmModal
        title={t("Order cancellation request")}
        onClose={() => {
          setConfirmModalOpen(false);
        }}
        isOpen={confirmModalOpen}
        loading={isPending}
        onSaveHandler={cancelOrderRequestHandler}
      />
    </div>
  );
};

export default TicketInfo;
